"use client";

import { c as _c } from "react/compiler-runtime";
import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import { DateFormatter } from "@sticker-giant/sg-frontend-common";
import type { Entry } from "contentful";
import Image from "next/image";
import Link from "next/link";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { parseLocalDate } from "@/lib/contentful/dates";
import { getEntry } from "@/lib/contentful/guards";
import type { TypeBlogArticleSkeleton } from "@/types/contentful/generated";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
interface Props {
  post: Entry<TypeBlogArticleSkeleton, undefined, string>;
}
export const BlogCard = t0 => {
  const $ = _c(48);
  const {
    post
  } = t0;
  const inspectorProps = useContentfulInspectorMode();
  const {
    headline,
    introSummary,
    featuredImage,
    author,
    publishedDate,
    slug
  } = post.fields;
  let T0;
  let T1;
  let formattedDate;
  let resolvedAuthor;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== author || $[1] !== featuredImage || $[2] !== headline || $[3] !== inspectorProps || $[4] !== introSummary || $[5] !== publishedDate || $[6] !== slug) {
    const resolvedImage = getEntry(featuredImage);
    let t7;
    if ($[17] !== author) {
      t7 = getEntry(author);
      $[17] = author;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    resolvedAuthor = t7;
    const imageData = ContentfulHelper.parseContentfulContentImage(resolvedImage?.fields.media);
    let t8;
    if ($[19] !== publishedDate) {
      const date = publishedDate ? parseLocalDate(publishedDate) : null;
      t8 = date && !Number.isNaN(date.getTime()) ? DateFormatter.formatToReadableDate(date) : null;
      $[19] = publishedDate;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    formattedDate = t8;
    const href = `/blog/${slug}`;
    T1 = Link;
    t4 = href;
    t5 = "no-underline! group hover:opacity-100!";
    t6 = `Read more: ${headline}`;
    T0 = Card;
    t1 = "flex flex-col h-full transition-shadow group-hover:shadow-md";
    let t9;
    if ($[21] !== headline) {
      t9 = <h2 className="line-clamp-2 text-base font-semibold leading-tight min-h-10">{headline}</h2>;
      $[21] = headline;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    let t10;
    if ($[23] !== introSummary) {
      t10 = <p className="line-clamp-2 font-sans text-sm font-normal leading-normal text-muted-foreground min-h-10">{introSummary}</p>;
      $[23] = introSummary;
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    if ($[25] !== t10 || $[26] !== t9) {
      t2 = <CardHeader>{t9}{t10}</CardHeader>;
      $[25] = t10;
      $[26] = t9;
      $[27] = t2;
    } else {
      t2 = $[27];
    }
    t3 = imageData && <CardContent><div className="relative aspect-video w-full overflow-hidden rounded-md bg-muted" {...resolvedImage ? inspectorProps({
        entryId: resolvedImage.sys.id,
        fieldId: "media"
      }) : {}}><Image src={imageData.src} alt={imageData.alt} fill={true} className="object-cover transition-transform duration-300 group-hover:scale-105" sizes="(min-width: 1024px) 33vw, 100vw" /></div></CardContent>;
    $[0] = author;
    $[1] = featuredImage;
    $[2] = headline;
    $[3] = inspectorProps;
    $[4] = introSummary;
    $[5] = publishedDate;
    $[6] = slug;
    $[7] = T0;
    $[8] = T1;
    $[9] = formattedDate;
    $[10] = resolvedAuthor;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    T0 = $[7];
    T1 = $[8];
    formattedDate = $[9];
    resolvedAuthor = $[10];
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
  }
  const t7 = `Author: ${resolvedAuthor?.fields.name}`;
  let t8;
  if ($[28] !== t7) {
    t8 = <p className="text-sm line-clamp-1">{t7}</p>;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== formattedDate) {
    t9 = formattedDate && <p className="text-sm font-light pb-6">{formattedDate}</p>;
    $[30] = formattedDate;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="inline-flex items-center justify-center w-full h-10 rounded-md border bg-background shadow-xs text-sm font-medium group-hover:bg-accent group-hover:text-accent-foreground transition-all">Read more</span>;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t8 || $[34] !== t9) {
    t11 = <CardFooter className="flex flex-col items-start mt-auto">{t8}{t9}{t10}</CardFooter>;
    $[33] = t8;
    $[34] = t9;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== T0 || $[37] !== t1 || $[38] !== t11 || $[39] !== t2 || $[40] !== t3) {
    t12 = <T0 className={t1}>{t2}{t3}{t11}</T0>;
    $[36] = T0;
    $[37] = t1;
    $[38] = t11;
    $[39] = t2;
    $[40] = t3;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== T1 || $[43] !== t12 || $[44] !== t4 || $[45] !== t5 || $[46] !== t6) {
    t13 = <T1 href={t4} className={t5} aria-label={t6}>{t12}</T1>;
    $[42] = T1;
    $[43] = t12;
    $[44] = t4;
    $[45] = t5;
    $[46] = t6;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  return t13;
};